import BusinessInfoClensingPage from 'pages/BusinessInfoClensingPage';
import LoginPage from 'pages/LoginPage';
import ReceiverClensingPage from 'pages/ReceiverClensingPage';
import SettingsPage from 'pages/SettingsPage';
import SignupPage from 'pages/SignupPage';
import TitleClensingPage from 'pages/TitleClensingPage';

import { RoutePropInterface } from 'types/CommonTypes';

const mainRoutes: RoutePropInterface[] = [
  {
    path: '/',
    name: '',
    element: TitleClensingPage,
  },
  {
    path: '/title-cleansing',
    name: '상품명 클랜징',
    element: TitleClensingPage,
  },
  {
    path: '/receiver-cleansing',
    name: '수취인 클랜징',
    element: ReceiverClensingPage,
  },
  {
    path: '/businessinfo-cleansing',
    name: '사업자정보 클랜징',
    element: BusinessInfoClensingPage,
  },
  {
    path: '/settings',
    name: '설정',
    element: SettingsPage,
  },
  {
    path: '/login',
    name: '로그인',
    element: LoginPage,
    isPublic: true,
    useHeader: false,
  },
  {
    path: '/signup',
    name: '회원가입',
    element: SignupPage,
    isPublic: true,
    useHeader: false,
  },
];

export default mainRoutes;
